import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import classnames from 'classnames'
import * as Sentry from '@sentry/browser'

import FeedListLoader from 'app/domains/common/Loaders/FeedListLoader'
import FeedListItemLoader from 'app/domains/common/Loaders/FeedListItemLoader'
import FeedRecentListItem from './FeedRecentListItem'
import FeedEmpty from '../FeedEmpty'
import FeedStoriesListItem from '../FeedStoriesList/FeedStoriesListItem'
import FeedRecentAchievementItem from 'app/domains/routes/Dashboard/UserBoard/Aside/Feed/FeedRecentList/FeedRecentAchievementItem/index'
import FeedRecentBadgeAchievementItem from 'app/domains/routes/Dashboard/UserBoard/Aside/Feed/FeedRecentList/FeedRecentBadgeAchievementItem/index'
import './styles.scss'
const bc = 'feed-list'

class FeedList extends React.Component {
  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtra('errorInfo', errorInfo)
      scope.setExtra('where error was happen', 'FeedList')
      scope.setExtra('event', JSON.stringify(this.props.event))
      scope.setExtra('timestamp', this.props.timestamp)
      scope.setExtra('user', this.props.user)
      Sentry.captureException(error)
    })
  }
  render() {
    const {
      recentList,
      pending,
      handleScroll,
      pendingLoadMore,
      identity,
      handleSetFeedEventLikeOld,
      setStoryReaction,
      setEventReaction,
      updateReaction,
      showStories,
      showReactions,
      loadStoryActivity,
      unreadStoryAuthor,
      hideNotification,
      height,
    } = this.props
    return pending ? (
      <FeedListLoader />
    ) : recentList.size ? (
      <div className={classnames('feed-list', { 'load-more': pendingLoadMore })}>
        <Scrollbars
          onScroll={handleScroll}
          autoHeight
          autoHeightMax={height}
          renderThumbVertical={props => <div {...props} className="scrollbar-thumb-vertical" />}
        >
          {unreadStoryAuthor &&
            unreadStoryAuthor.get('id') && (
              <div className={`${bc}__notification`} onAnimationEnd={hideNotification}>
                New story added by {unreadStoryAuthor.get('firstName')}!
              </div>
            )}
          {recentList.map((item, i) => {
            const itemData = item.toJS()
            const props = {
              index: i,
              key: i,
              identity,
              ...itemData,
            }
            if (itemData.activityUserStory && showStories) {
              return (
                <FeedStoriesListItem
                  {...props}
                  handleSetFeedStoryLikeOld={handleSetFeedEventLikeOld}
                  setReaction={setStoryReaction}
                  updateReaction={updateReaction}
                  showReactions={showReactions}
                  loadStoryActivity={loadStoryActivity}
                />
              )
            }
            if (itemData.event && itemData.event.name === 'achievement') {
              return (
                <FeedRecentAchievementItem
                  {...props}
                  handleSetFeedEventLikeOld={handleSetFeedEventLikeOld}
                  setReaction={setEventReaction}
                  updateReaction={updateReaction}
                  showReactions={showReactions}
                />
              )
            } else if (
              itemData.event &&
              itemData.sprint &&
              itemData.event.name === 'badgeAchievement' &&
              itemData.sprint.badge &&
              itemData.sprint.badgeTitle
            ) {
              return (
                <FeedRecentBadgeAchievementItem
                  {...props}
                  handleSetFeedEventLikeOld={handleSetFeedEventLikeOld}
                  setReaction={setEventReaction}
                  updateReaction={updateReaction}
                  showReactions={showReactions}
                />
              )
            }
            if (!itemData.event) {
              return null
            }
            return (
              <FeedRecentListItem
                {...props}
                setReaction={setEventReaction}
                updateReaction={updateReaction}
                showReactions={showReactions}
                handleSetFeedEventLikeOld={handleSetFeedEventLikeOld}
              />
            )
          })}
          {pendingLoadMore ? <FeedListItemLoader /> : null}
        </Scrollbars>
      </div>
    ) : (
      <FeedEmpty listType="recent" />
    )
  }
}

export default FeedList
